import { useState, useRef, useEffect } from "react";
import { useAuth } from "@hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { NotificationPanel } from "./NotificationPanel";
import { DummyAvatar } from "./ui/dummyAvatar";

export const Header = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const { logout, user } = useAuth();
  const navigate = useNavigate();

  // Fallback for different possible keys
  const { userName, username, name, profileImg } = user || {};
  const displayName = userName || username || name || "User";

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    }

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleChangeNavigation = (path) => {
    navigate(path);
    setIsDropdownOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md flex items-center justify-between whitespace-nowrap border-b border-solid border-slate-200/80 px-4 md:px-8 py-3 shadow-sm transition-all duration-300">
      {/* Left side: Logo and Title */}
      <div className="flex items-center gap-4 text-[#0d141c]">
        <img
          src="/logo.png"
          alt="Udyog Vriksh"
          className="h-8 md:h-10 w-auto"
          loading="lazy"
          decoding="sync"
        />
      </div>

      {/* Right side: Icons and User Menu */}
      <div className="flex items-center gap-5">
        {/* Notification Panel */}
        <NotificationPanel
          trigger={
            <div className="relative cursor-pointer mt-2">
              <button className="focus:outline-none">
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  ></path>
                </svg>
              </button>
            </div>
          }
        />

        {/* User Avatar and Dropdown */}
        <div className="relative cursor-pointer" ref={dropdownRef}>
          <button
            onClick={toggleDropdown}
            className="flex items-center gap-3 focus:outline-none"
          >
            {profileImg !== "undefined" && profileImg ? (
              <div
                className="bg-center bg-no-repeat aspect-square bg-cover rounded-full size-10"
                style={{ backgroundImage: `url(${profileImg})` }}
              />
            ) : (
              <DummyAvatar name={displayName} />
            )}
            <span className="text-sm font-medium text-gray-700 hidden md:block">
              {displayName}
            </span>
          </button>
          {isDropdownOpen && (
            <div className="absolute top-full right-0 mt-2 bg-white rounded-md shadow-lg border border-gray-200 w-48 z-10">
              <ul className="py-1">
                <li onClick={() => handleChangeNavigation("/feedback")}>
                  <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Feedback
                  </a>
                </li>
                <li onClick={() => handleChangeNavigation("/profile")}>
                  <a className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
                    Profile
                  </a>
                </li>
                <li onClick={handleLogout}>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>
    </header >
  );
};
